<template>
  <div>
    <div class="h-toolbarBg">
      <div class="h-inputBox">
        <div class="h-barSpace20"></div>
        <input class="e-input" :placeholder='$t("Software.serialNumber")' v-model="esnName"/>
        <div class="h-barSpace20"></div>
        <div class="h-barLit">{{$t('Software.distributionState')}}</div>
        <ejs-dropdownlist class="e-input" :fields="fieldsOfStatus" :dataSource="dataSourceOfStatus" :index='0' @change="changeForDetailStatus" v-model='selectEsnFlag'></ejs-dropdownlist>
      </div>
    </div>
    <div class='h100-40 h-scroll'>
      <ejs-grid ref='grid' :dataSource='dataForDHCPDetail' height='calc(100% - 0px)'>
        <e-columns>
          <e-column field='esn' :headerText='$t("Software.serialNumber")' textAlign='Center' width='25%' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='status' :headerText='$t("Software.td_status")' textAlign='Center' width='25%' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter="formatterOfDHCPDetailStatus"></e-column>
          <e-column field='allocatedIp' :headerText='$t("Software.ipAddress")' textAlign='Center' width='25%' clipMode='EllipsisWithTooltip' :isPrimaryKey='true'></e-column>
          <e-column field='eqtName' :headerText='$t("Software.td_neID")' textAlign='Center' width='25%' clipMode='EllipsisWithTooltip'></e-column>
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GridForDHCPDetail',
  props: [
    'eqtGrpId'
  ],
  data() {
    return {
      dataForDHCPDetail: [],
      dataStatus: new Map()
        .set(0, this.$t('Software.nonallocated'))
        .set(1, this.$t('Software.allocated')),
      dataSourceOfStatus: [
        { text: this.$t('Software.nonallocated'), value: '3' },
        { text: this.$t('Software.allocated'), value: '2' },
        { text: this.$t('Pm.all'), value: '1' },
      ],
      fieldsOfStatus: {
        text: 'text',
        value: 'value'
      },
      selectEsnFlag: '1',
      esnName: ''
    };
  },
  methods: {
    getDHCPDetailData() {
      this.$axios.post('/lte/eam/dhcp/getESNDetailsData.html', {
        eqtGrpId: this.eqtGrpId,
        selectEsnFlag: this.selectEsnFlag,
        esnName: this.esnName,
        page: {
          pageNo: 1,
          pageSize: 300
        },
      }).then((response) => {
        this.dataForDHCPDetail = response.data.resultVal.result;
      });
    },
    formatterOfDHCPDetailStatus(grids, data) {
      let color = '';
      if (data.status === 1) {
        color = 'black';
      } else {
        color = 'red';
      }
      return `<span style='background-color:${color};font-size: 12px;display: inline-block;width: 70px;height: 22px;color: #fff;line-height: 22px;' >${this.dataStatus.get(data.status)}</span>`;
    },
    changeForDetailStatus(msg) {
      this.selectEsnFlag = msg.value;
      this.getDHCPDetailData();
    }
  },
  watch: {
    eqtGrpId() {
      this.getDHCPDetailData();
    },
    esnName() {
      this.getDHCPDetailData();
    }
  }
};
</script>
